import React from 'react';
import { 
  Box, 
  Skeleton, 
  useTheme 
} from '@mui/material';

const InstrumentRowSkeleton = ({ count = 5 }) => {
  const theme = useTheme();

  return (
    <>
      {[...Array(count)].map((_, index) => (
        <Box 
          key={index} 
          sx={{
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between',
            p: 1,
            borderBottom: `1px solid ${theme.palette.divider}`
          }}
        >
          {/* Left side - Instrument details */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Skeleton 
              variant="circular" 
              width={40} 
              height={40} 
            />
            <Box>
              <Skeleton 
                variant="text" 
                width={120} 
                height={20} 
              />
              <Skeleton 
                variant="text" 
                width={80} 
                height={15} 
              />
            </Box>
          </Box>

          {/* Right side - Price and change */}
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <Skeleton 
              variant="text" 
              width={60} 
              height={20} 
            />
            <Skeleton 
              variant="text" 
              width={40} 
              height={15} 
            />
          </Box>
        </Box>
      ))}
    </>
  );
};

export default InstrumentRowSkeleton; 